<template>
	<div class="shadow_bg" id="clubClass_dialog_table">
		<div class="windows_table" :style="{ top: top + 'px' }">
			<div class="close_btn" @click="close_window"><img src="../../assets/img/close_icon.png"></div>
			<div class="opentab-header">学生未出勤明细</div>
			<div class="count_tip" v-if="show">共 {{ total }} 条数据</div>
			<div class="open_table" id="clubClass_edu_table">
				
			</div>
		</div>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
export default {
	data() {
		return {
			top: 0,
			total: 0,
			show: false
		}
	},
	mounted() {
		this.top = (document.body.clientHeight - 700) / 2;
		this.initData();
		let _this = this;
		window.onresize = function () { // 定义窗口大小变更通知事件
			_this.top = (document.documentElement.clientHeight - 700) / 2;
			console.log(_this.top);
		}
	},
	watch: {
		'top': function () { //监听屏幕高度变化
			this.top = (document.body.clientHeight - 700) / 2;
		}
	},
	methods: {
		close_window() {
			this.$emit("closeWin");
		},
		initData() {
			let _this = this;
			this.$http.get("/dataView/clubClass/edu/getOrgNotAttend?orgCode=" + orgCode).then(res => {
				if (res.data.code === 200) {
					let element = document.getElementById('clubClass_edu_table');
					if (res.data.result.length > 0) {
						var html = '<table class="pure-table"><thead><tr><th width="30%">学校</th><th width="20%">班级</th><th width="16%">姓名</th><th width="18%">课程</th><th width="16%">出勤状态</th></tr></thead>';
						html += '<tbody>';
						for (var i = 0; i < res.data.result.length; i++) {
							var obj = res.data.result[i];
							html += '<tr><td>' + obj.orgName + '</td><td>' + obj.gradeName + obj.clazzName + '</td><td>' + obj.stuName + '</td><td>' + obj.courseName + '</td><td>' + obj.attendStatus + '</td></tr>';
						}
						html += '</tbody></table>';
						element.innerHTML = html;
						_this.show = true;
						_this.total = res.data.result.length;
					} else {
						_this.show = false;
						element.innerHTML = '<div class="none_data"><img src="' + require("../../assets/img/none_icon.png") + '"><p style="color: #49b9ff">暂无数据</p></div>';
					}
				}
			})
		}
	}
}
</script>
<style lang="scss">
#clubClass_dialog_table {

	width: 100%;
	height: 100%;
	position: fixed;
	background: rgba(0, 0, 0, 0.6);
	padding: 0 !important;
	top: 0;
	left: 0;
	z-index: 999;

	.windows_table {
		width: 1000px;
		height: 700px;
		position: fixed;
		padding-top: 0.1rem;
		top: 200px;
		left: 50%;
		margin-Left: -500px;
		z-index: 9999;
		background-image: linear-gradient(135deg, #16304d, #060816);
		border-radius: 0.05rem;
		border: 1px solid #004774;
		box-shadow: 0 0 0.2rem #0075be;
	}

	.close_btn {
		position: absolute;
		width: 0.4rem;
		right: 0.15rem;
		top: 0.15rem
	}

	.close_btn img {
		width: 100%;
	}

	.close_btn:hover {
		cursor: pointer;
	}

	.opentab-header {
		width: 100%;
		height: 15%;
		text-align: center;
		background: url("../../assets/img/ac_titbg.png") center no-repeat;
		background-size: 100%;
		color: #34deff;
		font-size: 0.2rem;
		font-weight: bold;
		height: 0.8rem;
		line-height: 0.6rem;
	}

	.scroll_table {
		width: 100%;
		height: 7.8rem;
	}

	.scroll_table .leavelist .header {
		background: none;
		border-bottom: 1px solid #029aff;
		color: #029aff;
		font-size: 0.2rem;
		font-weight: bold;
	}

	.scroll_table .leavelist2 .row-item {
		color: #4ea4ff;
		font-size: 0.2rem;
	}

	.none_data {
		text-align: center;
		font-size: 0.3rem;
		height: 100%;
		padding-top: 100px;
	}

	.none_data img {
		width: 3rem;
	}

	.none_data p {
		line-height: 1rem;
	}

	// 表格样式
	.pure-table {
		border-collapse: collapse;
		border-spacing: 0;
		empty-cells: show;
		font-size: 0.2rem;
		width: 100%;
		table-layout: fixed;
	}

	.pure-table thead tr {
		background-image: linear-gradient(135deg, #16304d, #0d192d);
		position: sticky;
		top: 0;
		z-index: 2;
	}

	.pure-table tr>th {
		color: #06d2ff;
		padding: .25rem 0rem;
		border-bottom: 1px solid #005b94;
	}

	.pure-table td {
		text-align: center;
		margin: 0;
		overflow: visible;
		padding: .25rem 0rem;
	}

	.pure-table tr:nth-child(2n) {
		background: #152542;
	}

	.pure-table td {
		background-color: transparent;
		color: #49b9ff;
	}

	.open_table {
		height: 565px;
		overflow-y: auto;
	}

	.count_tip {
		width: 100%;
		line-height: 0.8rem;
		position: absolute;
		bottom: 0;
		left: 0;
		text-align: center;
		color: #49b9ff;
		text-align: center;
		font-size: 0.2rem;
	}

	.open_table::-webkit-scrollbar {
		width: 2px;
	}

	.open_table::-webkit-scrollbar-thumb {
		border-radius: 30%;
		background: linear-gradient(to bottom, rgba(16, 221, 191, 0.1), rgba(27, 118, 103, 0.1), rgba(20, 195, 221, 0.1));
	}

	.open_table::-webkit-scrollbar-track {
		border-radius: 30%;
		background: linear-gradient(to bottom, rgba(20, 195, 221, 0), rgba(11, 252, 252, 0.1), rgba(20, 195, 221, 0));
	}
}
</style>